import { render } from "./retrievePassword.vue?vue&type=template&id=5eec3b3a&scoped=true"
import script from "./retrievePassword.vue?vue&type=script&lang=js"
export * from "./retrievePassword.vue?vue&type=script&lang=js"

import "./retrievePassword.vue?vue&type=style&index=0&id=5eec3b3a&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eec3b3a"]])

export default __exports__